import { render } from "./SideBar.layout.vue?vue&type=template&id=39517f4d&ts=true"
import script from "./SideBar.layout.vue?vue&type=script&lang=ts"
export * from "./SideBar.layout.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\anc-transparencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__